import {useMutation} from '@tanstack/react-query';
import {uploadTempFiles} from '@/api/help/form';

/**
 * 문의하기 첨부파일을 임시 업로드하는 커스텀 Hook (Mutation)
 * @returns {UseMutationResult} React Query의 useMutation이 반환하는 객체
 */
export const useUploadTempFiles = () => {
  return useMutation({
    mutationFn: (files: File[]) => uploadTempFiles(files),
  });
};
